import { Helmet } from 'react-helmet-async';

const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://cititekpro.com/#organization",
    "name": "CitiTekPro",
    "legalName": "CitiTekPro LLC",
    "url": "https://cititekpro.com",
    "logo": {
      "@type": "ImageObject",
      "url": "https://cititekpro.com/logo.png",
      "width": 200,
      "height": 60
    },
    "description": "Full-service digital agency in Minneapolis, MN specializing in custom software development, web development, mobile apps, SEO, IT consulting, and business automation for businesses across Minnesota and the Twin Cities.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "2910 Pillsbury Ave, Suite 31",
      "addressLocality": "Minneapolis",
      "addressRegion": "MN",
      "postalCode": "55408",
      "addressCountry": "US"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "Sales",
        "email": "contact@cititekpro.com",
        "availableLanguage": ["English"]
      },
      {
        "@type": "ContactPoint",
        "contactType": "Customer Service",
        "email": "support@cititekpro.com",
        "availableLanguage": ["English"]
      }
    ],
    "sameAs": [
      "https://www.facebook.com/cititekpro",
      "https://www.linkedin.com/company/cititekpro",
      "https://www.instagram.com/cititekpro"
    ],
    "areaServed": [
      { "@type": "City", "name": "Minneapolis" },
      { "@type": "City", "name": "Saint Paul" },
      { "@type": "City", "name": "Bloomington" },
      { "@type": "City", "name": "Brooklyn Park" },
      { "@type": "City", "name": "Brooklyn Center" },
      { "@type": "City", "name": "Plymouth" },
      { "@type": "City", "name": "Maple Grove" },
      { "@type": "City", "name": "Richfield" },
      { "@type": "City", "name": "Burnsville" },
      { "@type": "City", "name": "Eagan" },
      { "@type": "City", "name": "Roseville" },
      { "@type": "City", "name": "Edina" },
      { "@type": "State", "name": "Minnesota" }
    ],
    "slogan": "Transform Your Business with Expert Digital Solutions"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default OrganizationSchema;
